import React, { Suspense } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { StylesProvider, Theme, ThemeProvider } from '@material-ui/core';
import { getMaterialUIConfiguration } from '../../helpers/stylesUtils';
import { DashboardSnackbarProvider } from '../providers/DashboardSnackbarProvider';
import { SocketsClientConfig } from '../components/SocketsClientConfig/SocketsClientConfig';
import { DataTrackerClientConfigurator } from '../components/DataTrackerClientConfig/DataTrackerClientConfigurator';
import { UserLaneClientConfig } from '../components/UserLaneClientConfig/UserLaneClientConfig';
import { Spinner, SpinnerAlignment } from '../components/Spinner/Spinner';
import Dashboard from './Dashboard/Dashboard';
import { IdleTimerContainer } from '../components/IdleTimerContainer/IdleTimerContainer';

export type AppProps = {
    theme: Theme;
};

export const App = ({ theme }: AppProps) => {
    return (
        <ThemeProvider theme={theme}>
            <StylesProvider generateClassName={getMaterialUIConfiguration()}>
                <Suspense fallback={<Spinner alignment={SpinnerAlignment.CENTERED} />}>
                    <IdleTimerContainer />
                    <Router>
                        <DashboardSnackbarProvider>
                            <SocketsClientConfig />
                            <DataTrackerClientConfigurator />
                            <UserLaneClientConfig />
                            <Dashboard />
                        </DashboardSnackbarProvider>
                    </Router>
                </Suspense>
            </StylesProvider>
        </ThemeProvider>
    );
};
